import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function Counter({
  from,
  to,
  duration = 2,
  suffix = ''
}: {
  from: number;
  to: number;
  duration?: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(from);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  useEffect(() => {
    if (!isInView) return;
    let startTime: number;
    let animationFrame: number;
    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / (duration * 1000), 1);
      // easeOutExpo
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      setCount(Math.floor(easeProgress * (to - from) + from));
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animationFrame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationFrame);
  }, [isInView, from, to, duration]);
  return <span ref={ref} data-id="element-134">
      {count}
      {suffix}
    </span>;
}
export function Stats() {
  const stats = [{
    value: 250,
    suffix: '+',
    label: 'פרויקטים'
  }, {
    value: 60,
    suffix: '',
    label: 'פרסים'
  }, {
    value: 12,
    suffix: '',
    label: 'שנות ניסיון'
  }, {
    value: 98,
    suffix: '%',
    label: 'לקוחות חוזרים'
  }];
  return <section className="py-24 border-y border-white/5 bg-[#0a0a0f]/50 relative z-20" data-id="element-135">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-136">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-8" data-id="element-137">
          {stats.map((stat, index) => <motion.div key={index} className="text-center" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-138">
              <div className="text-5xl md:text-6xl font-display font-black text-white mb-2" data-id="element-139">
                <Counter from={0} to={stat.value} suffix={stat.suffix} data-id="element-140" />
              </div>
              <div className="text-white/50 font-medium text-lg" data-id="element-141">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}